'use client'

import type { ReactNode } from 'react'
import { Button } from '@/General/Button'
import { tracking } from '@/tracking'
import { SIGNUP_PRODUCT, REGISTRATION_PATH } from '../config'
import { MAGIFEST_BUTTON_CLASS } from '../styles'

export type MagifestRegistrationPlacement =
  | 'header'
  | 'ticket-comparison'
  | 'introduction'
  | 'performers'
  | 'vip'
  | 'final'
  | 'sticky'

type MagifestRegistrationButtonProps = {
  children: ReactNode
  placement: MagifestRegistrationPlacement
  className?: string
  size?: 'sm' | 'md' | 'lg'
}

export const MAGIFEST_REGISTRATION_PATH = REGISTRATION_PATH

export function MagifestRegistrationButton({
  children,
  placement,
  className,
  size = 'md',
}: MagifestRegistrationButtonProps) {
  return (
    <Button
      href={MAGIFEST_REGISTRATION_PATH}
      className={`${MAGIFEST_BUTTON_CLASS} ${className || ''}`}
      size={size}
      onClick={() =>
        tracking.track('Clicked convention registration CTA', {
          conventionSlug: 'magifest',
          conventionProductSlug: SIGNUP_PRODUCT,
          placement,
          destinationUrl: MAGIFEST_REGISTRATION_PATH,
        })
      }
    >
      {children}
    </Button>
  )
}
